import { ListingVariant } from '../../../../models/ClientModels';
import { ChatUser } from './chatUser';
export enum MsgSendStatus {
  sending = 1,
  success = 2,
  fail = 3,
}

export enum ChatMessageType {
  SystemMessage = 0,
  Text = 1,
  Picture = 2,
  Product = 3,
  Order = 4,
  Video = 5,
}

export type ChatMessageBase = {
  messageId: number | string;
  clientId: string;
  from: ChatUser;
  to?: ChatUser;
  sessionId?: string;
  chatSessionId?: number | string;
  roomId: string;
  time: number;
  type: ChatMessageType;
  customType?: string;
  text?: string;
  quoteMsg?: ChatMessage;
};

export type ChatTextMessage = ChatMessageBase & {
  type: ChatMessageType.Text;
  content: TextContent;
};

export type ChatSystemMessage = ChatMessageBase & {
  type: ChatMessageType.SystemMessage;
  content: SystemMessageContent;
};

export type ChatPictureMessage = ChatMessageBase & {
  type: ChatMessageType.Picture;
  content: ImageContent;
};

export type ChatVideoMessage = ChatMessageBase & {
  type: ChatMessageType.Video;
  content: VideoContent;
};

export type ChatOrderMessage = ChatMessageBase & {
  type: ChatMessageType.Order;
  content: OrderContent;
};

export type ChatProductMessage = ChatMessageBase & {
  type: ChatMessageType.Product;
  content: ProductContent;
};

export type ChatMessage =
  | ChatTextMessage
  | ChatPictureMessage
  | ChatVideoMessage
  | ChatOrderMessage
  | ChatProductMessage
  | ChatSystemMessage;

export type ClientChatMessage = ChatMessage & {
  // Only client have the status.
  lastSendTime: number;
  sendStatus: MsgSendStatus;
  lastSendErrorMsg?: string;
};

export interface TextContent {
  text: string;
}

export type ImageContent = {
  width: number;
  height: number;
} & (
  | {
      localFileUri: string;
    }
  | {
      imageUrl: string;
      thumbnailUrl?: string;
    }
);

export type VideoThumbnail = {
  width: number;
  height: number;
} & (
  | {
      localFileUri: string;
    }
  | { url: string }
);

export type VideoContent = {
  width?: number;
  height?: number;
  thumbnail?: VideoThumbnail;
} & (
  | {
      localFileUri: string;
    }
  | {
      videoUrl: string;
    }
);

export type OrderContent = {
  orderId: string;
  orderNumber: string;
  imageUrl: string;
  orderTitle: string;
  price: number;
  quantity: number;
  sellerId: string;
  sellerName: string;
  buyerId: string;
  buyerName: string;
  orderDate: string;
  from: 'buyer' | 'seller';
};

export type ProductContent = {
  id: string;
  imageUrl: string;
  name: string;
  quantity: number;
  price: number;
  discountPrice?: number;
  variants: ListingVariant[] | undefined;
  storeId: string;
  storeName: string;
};

export type CustomContent = {
  data: any;
};

export enum SystemMessageType {
  Text = 1,
  OrderAnnouncement = 2,
}

export type SystemMessageContent =
  | {
      type: SystemMessageType.Text;
      content: TextContent;
    }
  | {
      type: SystemMessageType.OrderAnnouncement;
      content: OrderContent;
    };
